<template>
  <div class="d-flex align-items-center min-vh-100">
    <CContainer fluid>
      <CRow class="justify-content-center">
        <CCol md="6">
          <CCard class="mx-4 mb-0">
            <CCardBody class="p-4">
              <CForm>
                <h1>Register</h1>
                <p class="text-muted">Create your account</p>
                <CInput
                  placeholder="Username"
                  autocomplete="username"
                  :value.sync="username"
                  disabled
                >
                  <template #prepend-content>
                    <CIcon name="cil-user" />
                  </template>
                </CInput>
                <CInput
                  placeholder="Email"
                  autocomplete="email"
                  prepend="@"
                  :value.sync="email"
                  disabled
                />
                <CInput
                  placeholder="Password"
                  type="password"
                  autocomplete="new-password"
                  :value.sync="password"
                  disabled
                >
                  <template #prepend-content>
                    <CIcon name="cil-lock-locked" />
                  </template>
                </CInput>
                <CInput
                  placeholder="Repeat Password For Verify"
                  type="password"
                  autocomplete="new-password"
                  :value.sync="passwordVerify"
                  disabled
                >
                  <template #prepend-content>
                    <CIcon name="cil-lock-unlocked" />
                  </template>
                </CInput>
                <CSelect
                  placeholder="Contact Info Type"
                  :options="imTypeList"
                  :value.sync="imType"
                  disabled
                >
                  <template #prepend-content>
                    <CIcon name="cil-chat-bubble" />
                  </template>
                </CSelect>
                <CInput
                  placeholder="Contact Info"
                  class="mb-4"
                  :value.sync="imInfo"
                  disabled
                >
                  <template #prepend-content>
                    <CIcon name="cil-comment-bubble" />
                  </template>
                </CInput>
              </CForm>
            </CCardBody>
            <CCardFooter class="p-4">
              <CRow>
                <CCol col="6">
                  <CButton block color="primary" @click="register" disabled>
                    Register
                  </CButton>
                </CCol>
                <CCol col="6">
                  <CButton block color="success" @click="$router.push('/auth/login')">
                    Go to login
                  </CButton>
                </CCol>
                <CCol col="12">
                  <hr>
                  <p class="text-muted">AirmyLife ☁️ © 2022 All Rights Reserved.</p>
                </CCol>
              </CRow>
            </CCardFooter>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
    <CModal
      title="Register"
      color="primary"
      :show.sync="registerMsgModal"
    >
      {{ registerMsg }}
    </CModal>
  </div>
</template>

<script>
export default {
  name: "Register",
  data() {
    return {
      username: null,
      email: null,
      password: null,
      passwordVerify: null,
      imType: null,
      imInfo: null,
      registerMsg: null,
      registerMsgModal: false,
      imTypeList: [
        { label: "Select Your IM Type" },
        { value: 1, label: "Wechat" },
        { value: 2, label: "Tencent QQ" },
        { value: 3, label: "Facebook" },
        { value: 4, label: "Telegram" }
      ]
    };
  },
  mounted: function() {
    this.onLoadPage();
  },
  methods: {
    onLoadPage: function() {
      this.registerMsg = "We are no longer accept new user." +
        "Thanks! See you.";
      this.registerMsgModal = true;
    },
    register: function() {
      this.registerMsgModal = true;
      this.$axios.post("auth/register", {
        username: this.username,
        email: this.email,
        password: this.password,
        re_password: this.passwordVerify,
        im_type: this.imType,
        im_info: this.imInfo
      }, {})
        .then((response) => {
          this.registerMsg = response.data.msg;
          if (response.data.code === 200) {
            setTimeout(() => this.$router.push({ path: "/auth/login" }), 3000);
          }
        });
    }
  }
};
</script>
